import React from 'react';
import loadable from '@loadable/component'

import { withError } from '../../shared/components/error-boundary';
import '../css/main.less';

const SalePage  = loadable(() => import('../../sale-page'));
const SalePageTemplate = loadable(() => import('../../sale-page/components/sale-page-template'));
const GiftGuide = loadable(() => import('../../gift-guide/components/gift-guide'));

const Main = React.memo(
	(props) => (
		<SalePageTemplate {...props}>
			{
				(salePageTemplateProps) => {
					let {templateKey} = salePageTemplateProps || {};
					switch(templateKey){
						case 'gift-guide':
							return <GiftGuide {...salePageTemplateProps}/>;
						case 'sale-v4':
						case 'sale-v3':
							return <SalePage {...salePageTemplateProps}/>;
					}
					return null;
				}
			}
		</SalePageTemplate>
	)
);

Main.whyDidYouRender = true;

export default withError(Main);
